<app-loader [show]="isLoading"></app-loader>
<div class="employee-cat-component-container page-root-container">
        <div class="page-header">
                <div class="page-title">

                        <img class="icon" src="assets/images/menu/svg/employees.svg"><span class="title">Employee</span>
                </div>
                <div class="page-actions">
                        @if(permission.can_add){
                        <button mat-button color="primary" class="btn-add"
                                (click)="addClicked()"><mat-icon>person_add</mat-icon>New</button>
                        }
                        @if(permission.can_export || permission.can_execute){
                        <button mat-button color="accent" class="btn-export" (click)="exportClicked()"
                                [disabled]="IsDownloading">
                                <img class="download-icon"
                                        [src]="IsDownloading ? 'assets/images/animated/download/download-anim.svg' : 'assets/images/animated/download/download-no-anim.svg'">
                                Export
                        </button>
                        }
                </div>
        </div>

        <div class="data-container">

                <!-- <app-search-filter #searchFilter [length]="pagingData.length" [pageSize]="pagingData.pageSize"
                        [pageSizeOptions]="[5,10,20,50,100]" [pageIndex]="pagingData.pageIndex" [filter]="filter"
                        (page)="onePageEvent($event)" (onApply)="onFilterApplied($event)"  [hidePageSize]="true">
                </app-search-filter> -->
                <app-search-filter #searchFilter [pagingData]="pagingData" [pageSizeOptions]="[5,10,20,50,100]"
                        [filter]="filter" (page)="onePageEvent($event)" (onApply)="onFilterApplied($event)"
                        [hidePageSize]="true">
                </app-search-filter>
                <!-- <ng-container *ngIf="pagingData.length>0; else nodata"> -->
                <!-- @if(pagingData.length > 0){
                                @if(!isHandset){ -->
                <section tabindex="0" class="table-container">
                        <table matSort (matSortChange)="sortData($event)" mat-table [dataSource]="dataSource">
                                <ng-container matColumnDef="item">
                                        <th mat-header-cell *matHeaderCellDef (click)="sortData($event)"
                                                class="item-header">#</th>
                                        <td mat-cell *matCellDef="let employees; let i = index" class="item-column">{{
                                                (pagingData.pageIndex*pagingData.pageSize) + i + 1 }}</td>
                                </ng-container>
                                <ng-container matColumnDef="id">
                                        <th mat-sort-header="id" mat-header-cell style="width: 80px;" *matHeaderCellDef
                                                (click)="sortData($event)">Id</th>
                                        <td mat-cell *matCellDef="let employees" style="width: 80px;">
                                                {{employees.id}}
                                        </td>
                                </ng-container>

                                <ng-container matColumnDef="f_name">
                                        <th mat-sort-header="f_name" mat-header-cell *matHeaderCellDef
                                                (click)="sortData($event)"> Name </th>
                                        <td mat-cell *matCellDef="let employees"> {{employees.f_name}}
                                                {{employees.m_name}} {{employees.l_name}}
                                        </td>
                                </ng-container>

                                <ng-container matColumnDef="shop">
                                        <th mat-sort-header="shop" mat-header-cell *matHeaderCellDef
                                                (click)="sortData($event)"> Shop </th>
                                        <td mat-cell *matCellDef="let employees">
                                                <ng-container
                                                        *ngIf="getAssignedShops(employees.all_shop_names).length > 1; else singleShop">
                                                        <span class="shop-name-clickable" [matMenuTriggerFor]="shopMenu"
                                                                (click)="$event.stopPropagation()"
                                                                style="cursor: pointer; color: #1976d2; display: inline-flex; align-items: center; gap: 4px;">
                                                                {{employees.primary_shop_name ||
                                                                getAssignedShops(employees.all_shop_names)[0]}}
                                                                <mat-icon class="shop-icon"
                                                                        style="font-size: 16px; width: 16px; height: 16px;">storefront</mat-icon>
                                                        </span>
                                                        <mat-menu #shopMenu="matMenu">
                                                                <div mat-menu-item
                                                                        *ngFor="let shop of getAssignedShops(employees.all_shop_names)">
                                                                        {{shop}}
                                                                </div>
                                                        </mat-menu>
                                                </ng-container>
                                                <ng-template #singleShop>
                                                        <span>{{employees.primary_shop_name ||
                                                                getAssignedShops(employees.all_shop_names)[0]}}</span>
                                                </ng-template>
                                        </td>
                                </ng-container>
                                <ng-container matColumnDef="payroll_code">
                                        <th mat-sort-header="payroll_code" mat-header-cell *matHeaderCellDef
                                                (click)="sortData($event)"> Payroll Code </th>
                                        <td mat-cell *matCellDef="let employees"> {{employees.payroll_code}}
                                        </td>
                                </ng-container>
                                <ng-container matColumnDef="gender">
                                        <th mat-sort-header="gender" mat-header-cell *matHeaderCellDef
                                                (click)="sortData($event)"> Gender </th>
                                        <td mat-cell *matCellDef="let employees"> {{employees.gender}}
                                        </td>
                                </ng-container>
                                <!-- <ng-container matColumnDef="address">
                                        <th mat-sort-header="address" mat-header-cell *matHeaderCellDef
                                                (click)="sortData($event)"> Address </th>
                                        <td mat-cell *matCellDef="let employees"> {{employees.address}}
                                        </td>
                                </ng-container> -->
                                <ng-container matColumnDef="employee_type">
                                        <th mat-sort-header="employee_type" mat-header-cell *matHeaderCellDef
                                                (click)="sortData($event)"> Employee Type </th>
                                        <td mat-cell *matCellDef="let employees">
                                                <!-- @if(employees.wage_type == 1){
                                                Hourly
                                                }
                                                @if(employees.wage_type == 2){
                                                Daily
                                                } -->
                                                {{employees.employee_type}}
                                        </td>
                                </ng-container>
                                <ng-container matColumnDef="job_position">
                                        <th mat-sort-header="job_position" mat-header-cell *matHeaderCellDef
                                                (click)="sortData($event)"> Job Position </th>
                                        <td mat-cell *matCellDef="let employees"> {{employees.job_position}}
                                        </td>
                                </ng-container>
                                <ng-container matColumnDef="phone">
                                        <th mat-sort-header="phone" mat-header-cell *matHeaderCellDef
                                                (click)="sortData($event)"> Phone </th>
                                        <td mat-cell *matCellDef="let employees"> {{employees.phone}}
                                        </td>
                                </ng-container>
                                <!-- <ng-container matColumnDef="email">
                                        <th mat-sort-header="email" mat-header-cell *matHeaderCellDef
                                                (click)="sortData($event)"> Email </th>
                                        <td mat-cell *matCellDef="let employees"> {{employees.email}}
                                        </td>
                                </ng-container> -->
                                <ng-container matColumnDef="employee_status">
                                        <th mat-sort-header="employee_status" mat-header-cell *matHeaderCellDef
                                                (click)="sortData($event)"> Status </th>

                                        <td mat-cell *matCellDef="let employees">
                                                <!-- @if(employees.status == 1){
                                                <div class="active-status">
                                                        Active
                                                </div>

                                                }

                                                @if(employees.status == 2){
                                                <div class="resigned-status">Resigned</div>
                                                } -->
                                                <div
                                                        [ngClass]="{'active-status': employees.employee_is_active_status == 1, 'resigned-status': employees.employee_is_active_status == 0}">
                                                        {{employees.employee_status}}</div>
                                        </td>
                                </ng-container>
                                <ng-container matColumnDef="action" stickyEnd>
                                        <th mat-header-cell *matHeaderCellDef> </th>
                                        <td mat-cell class="row-menu-btn" style="width:50px" *matCellDef="let rowItem">
                                                <a mat-icon-button class="row-menu-btn" [matMenuTriggerFor]="rowMenu"
                                                        (click)="onRowSelected(rowItem);$event.stopPropagation();">
                                                        <mat-icon>more_vert</mat-icon>
                                                </a>

                                                <mat-menu #rowMenu>
                                                        @if(permissionService.getRowPermission(permission,rowItem.id).can_delete){
                                                        <button mat-menu-item
                                                                (click)="onDelete(rowItem)">Delete</button>
                                                        }
                                                        @if(permissionService.getRowPermission(permission,rowItem.id).can_edit){
                                                        <button mat-menu-item (click)="onEdit(rowItem)">Edit</button>
                                                        }@else{
                                                        <button mat-menu-item (click)="onEdit(rowItem)">View</button>
                                                        }
                                                        <button mat-menu-item (click)="openJobBreak(rowItem)">
                                                                <span>Job Break</span>
                                                        </button>
                                                </mat-menu>
                                        </td>
                                </ng-container>

                                <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true">
                                </tr>
                                <tr mat-row class="table-element-row"
                                        *matRowDef="let employees; columns: displayedColumns;"
                                        (click)="onRowSelected(employees)" (dblclick)="onEdit(employees)"
                                        [ngClass]=" {'row-selected' : employees.id===selectedItem?.id}">
                                </tr>
                        </table>
                </section>

                <!-- </ng-container> -->
                <!-- <ng-template #nodata> -->
                @if(pagingData.length<=0){ <div class="no-data-container">
                        <img src="assets/images/no-data.png">
                        <span class="no-data-info">No data found. Please remove or redefine the filters if
                                any.</span>
        </div>
        <!-- </ng-template> -->
        }
</div>

</div>

<!-- <app-employee-ext-employees-summary [employee]="selectedItem" (onEdit)="onEdit($event)" (onDelete)="onDelete($event)"></app-employee-ext-employees-summary> -->